import React, { useState } from "react";
import { toast } from "sonner";
import { Pencil, Trash2, Users } from "lucide-react";
import api from "../../lib/api";

const STATUS = { pending: ["Belum dikirim", "border-[#F2D98D] text-[#F2D98D]"], done: ["Selesai", "border-[#35C78A] text-[#35C78A]"] };

function Line({ label, value }) {
  if (!value) return null;
  return <div className="flex gap-2 text-xs"><span className="text-[#A8A8AD] w-20 shrink-0">{label}</span><span className="text-[#F5F3ED] break-words min-w-0">{value}</span></div>;
}

export default function NoteCard({ n, onEdit, onChanged, onDeleted, onBuyer }) {
  const [confirm, setConfirm] = useState(false);
  const [label, cls] = STATUS[n.status] || STATUS.pending;

  const toggle = async () => {
    try { const r = await api.patch(`/internal-notes/${n.id}`, { status: n.status === "done" ? "pending" : "done" }); onChanged(r.data); }
    catch (err) { toast.error(err?.response?.data?.detail || "Gagal mengubah status"); }
  };
  const del = async () => {
    if (!confirm) { setConfirm(true); setTimeout(() => setConfirm(false), 3000); return; }
    try { await api.delete(`/internal-notes/${n.id}`); onDeleted(n.id); toast.success("Catatan dihapus"); }
    catch (err) { toast.error(err?.response?.data?.detail || "Gagal menghapus"); }
  };

  return (
    <div data-testid={`note-card-${n.id}`} className="bg-[#202127] border border-[#35353B] hover:border-[#D4AF37]/50 rounded-md p-3 space-y-1 transition-colors">
      <div className="flex items-center justify-between gap-2 mb-1">
        <button data-testid={`note-status-toggle-${n.id}`} onClick={toggle} title="Ubah status" className={`text-[10px] uppercase tracking-widest border rounded-full px-2 py-0.5 ${cls}`}>{label}</button>
        <div className="flex items-center gap-1">
          <button data-testid={`note-edit-${n.id}`} onClick={() => onEdit(n)} className="p-1 text-[#A8A8AD] hover:text-[#D4AF37] transition-colors"><Pencil size={13} /></button>
          <button data-testid={`note-delete-${n.id}`} onClick={del} className={`p-1 transition-colors ${confirm ? "text-[#F06464]" : "text-[#A8A8AD] hover:text-[#F06464]"}`}>{confirm ? <span className="text-[10px] font-bold">Hapus?</span> : <Trash2 size={13} />}</button>
        </div>
      </div>
      <Line label="Supplier" value={n.supplier_name} />
      <Line label="Buyer" value={n.buyer_name} />
      <Line label="Gold" value={n.gold_amount} />
      <Line label="ID karakter" value={n.character_id} />
      <Line label="Server" value={n.server} />
      {n.note && <div className="text-xs text-[#F5F3ED]/90 whitespace-pre-wrap break-words border-t border-[#35353B] pt-1.5 mt-1.5">{n.note}</div>}
      <div className="flex items-center justify-between pt-1">
        <span className="text-[10px] text-[#A8A8AD]">{new Date(n.updated_at || n.created_at).toLocaleString([], { dateStyle: "short", timeStyle: "short" })}</span>
        {n.buyer_name && <button data-testid={`note-buyer-all-${n.id}`} onClick={() => onBuyer(n.buyer_name)} className="flex items-center gap-1 text-[10px] text-[#D4AF37] hover:underline"><Users size={11} /> Semua supplier buyer ini</button>}
      </div>
    </div>
  );
}
